/**
 * Calculated material consumption of a production entry (F4 / 0180).
 * Subcollection: org/{orgId}/production-entry/{productionEntryId}/material
 *
 * Lean, no lifecycle/audit (subcollection convention). The row is written even
 * when stock is off (`not-applicable`) — the consumption record has value on
 * its own (traceability now, costing later). Resolve with context
 * `{ orgId, productionEntryId }`.
 */
export const PRODUCTION_ENTRY_MATERIAL = 'ProductionEntryMaterial';
//# sourceMappingURL=production-entry-material.js.map